<div class="dex-tranche-compos_table-wrapper" customScrollbar>
    <div class="dex-tranche-compos_complex-table" [table]="table" #tableElement>
        <div class="dex-tranche-compos_table-header-wrapper">
            <table class="dex-tranche-compos_table">
                <thead>
                <tr tableHeaderRow>
                    <th textHiding *tableColumn="table.columnsDict.PERCENT; let column" class="dex-tranche-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.SYMBOL; let column" class="dex-tranche-compos_table_header"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.TICK; let column" class="dex-tranche-compos_table_header">
                        <span>
                            <svg class="dex-tranche-compos_table_header_tick-column-icon">
                                <use xlink:href="#plus-arrow-down"></use>
                            </svg>
                        </span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.BALANCE; let column" class="dex-tranche-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.ENTRY_VALUE_USD; let column" class="dex-tranche-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.RATE_USD; let column" class="dex-tranche-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.PORTFOLIO_VALUE_USD; let column" class="dex-tranche-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.YIELD_PERCENT; let column" class="dex-tranche-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.SNAPSHOT; let column" class="dex-tranche-compos_table_header"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="dex-tranche-compos_table-body-wrapper" customScrollbar elementRuler>
            <table class="dex-tranche-compos_table">
                <tbody>
                <tr *tableBodyRow="let _row of table.rows; let rowIndex = index"
                    class="dex-tranche-compos_table_row">

                    @let row = getTypedRow(_row);

                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -align-right"
                        tooltip #percentTooltip="tooltip">
                        <span>
                            @if (rowIndex) {
                                <div class="dex-tranche-compos_table_cell_color -color-{{rowIndex}}"></div>
                                <span [displayDecimal]="row.percent" [decimalCount]="2" currency="%" [tooltipDirective]="percentTooltip"></span>
                            } @else {
                                N/A
                            }
                        </span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -symbol"
                        [tooltip]="row.symbol">
                        <span>
                            {{row.symbol}} <span class="-full-name"></span>
                        </span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell"
                        [class.-no-tick]="!row.tick"
                        [tooltip]="row.tick | dexTrancheTableTick">
                        <span>{{row.tick | dexTrancheTableTick}}</span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -align-right"
                        tooltip #balanceTooltip="tooltip">
                        <span [displayDecimal]="row.raw.balance | valueWithDelDisplayDecimal:false" [tooltipDirective]="balanceTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -align-right"
                        tooltip #entryValueUsdTooltip="tooltip">
                        <span [displayDecimal]="row.raw.entryValue | valueWithDelDisplayDecimal:false" [tooltipDirective]="entryValueUsdTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -align-right"
                        tooltip #rateUsdTooltip="tooltip">
                        <span [displayDecimal]="row.raw.referenceRate | valueWithDelDisplayDecimal:false" [tooltipDirective]="rateUsdTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -align-right"
                        tooltip #portfolioValueUsdTooltip="tooltip">
                        <span [displayDecimal]="row.raw.portfolioValue | valueWithDelDisplayDecimal:false" [tooltipDirective]="portfolioValueUsdTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -align-right"
                        tooltip #yieldPercentTooltip="tooltip">
                        <span [displayDecimal]="row.raw.yield.v | bigintDisplayDecimal:row.raw.yield.dp:'%'" [tooltipDirective]="yieldPercentTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-tranche-compos_table_cell -chart">
                        <span>
                            <span class="dex-tranche-compos_table_cell_chart"
                                  [class.-positive]="row.raw.yield.v > 0"
                                  [class.-negative]="row.raw.yield.v < 0">
                                <sparkline
                                    [width]="74.5"
                                    [height]="20"
                                    [strokeWidth]="1"
                                    [data]="row.raw.raw | dexTrancheSparkline | async"
                                    [tick]="row.raw.yieldNumber"
                                    [gradientOpacity]="0.5">
                                </sparkline>
                            </span>
                        </span>
                    </td>
                </tr>

                <!-- EMPTY ROWS -->
                <tr *tableBodyEmptyRow class="dex-tranche-compos_table_row -empty">
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                    <td *tableColumn class="dex-tranche-compos_table_cell"></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
